export const isIE = (userAgent) => {
    return userAgent && userAgent.indexOf('Trident') > -1;
};

export const isWebview = (userAgent) => {
    return userAgent && userAgent.indexOf('app.webview') > -1;
};
